import { render, staticRenderFns } from "./framePlan.vue?vue&type=template&id=46b45270&scoped=true&"
import script from "./framePlan.vue?vue&type=script&lang=js&"
export * from "./framePlan.vue?vue&type=script&lang=js&"
import style0 from "./framePlan.vue?vue&type=style&index=0&id=46b45270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b45270",
  null
  
)

export default component.exports